import { Estimation } from '../models/estimation.model';
import { UpdateEstimationForm } from '../models/update-estimation-form.model';

export class UpdateFormEstimationMapper {
    constructor(public readonly newEstimationRequest: UpdateEstimationForm) {}

    static fromEstimation(estimation: Estimation): UpdateFormEstimationMapper {
        const { propertyCharacteristics, intent, portal } = estimation;
        const {
            address: { cityName, houseNumber, postalCode, streetName },
            legacyLocation: { addressId, streetId, cityId },
        } = propertyCharacteristics;

        return new UpdateFormEstimationMapper({
            portal,
            platform: estimation.platform,
            keepPreviousPropertyCharacteristics: false,
            estimationId: estimation.id,

            cityName,
            houseNumber,
            postalCode,
            streetName,

            // geo reference ids
            addressId,
            streetId,
            cityId,

            estateType: propertyCharacteristics.estateType,

            estateSubType: propertyCharacteristics.estateSubType,

            // PropertyCharacteristics
            // Area / Structure
            livingSurface: propertyCharacteristics.surfaceAreas.livingSurface,
            numberOfRooms: propertyCharacteristics.numberOfAreas.numberOfRooms,
            numberOfBathRooms: propertyCharacteristics.numberOfAreas.numberOfBathRooms,
            numberOfBedRooms: propertyCharacteristics.numberOfAreas.numberOfBedRooms,
            floorNumber: propertyCharacteristics.structure.floorNumber,
            numberOfFloorsInBuilding: propertyCharacteristics.structure.numberOfFloorsInBuilding,
            numberOfFacades: propertyCharacteristics.structure.numberOfFacades,
            totalSiteSurface: propertyCharacteristics.surfaceAreas.totalSiteSurface,
            balconiesAndTerracesSurface:
                propertyCharacteristics.surfaceAreas.balconiesAndTerracesSurface,
            hasABalconyOrTerrace: propertyCharacteristics.areas.hasABalconyOrTerrace,
            hasACellar: propertyCharacteristics.areas.hasACellar,
            hasABasement: propertyCharacteristics.areas.hasABasement,
            basementsSurface: propertyCharacteristics.surfaceAreas.basementsSurface,

            // Features
            hasAnElevator: propertyCharacteristics.features.hasAnElevator,
            hasAnIndoorParking: propertyCharacteristics.features.hasAnIndoorParking,
            hasAnOutdoorParking: propertyCharacteristics.features.hasAnOutdoorParking,
            numberOfIndoorParkingLots:
                propertyCharacteristics.numberOfFeatures.numberOfIndoorParkingLots,
            numberOfOutdoorParkingLots:
                propertyCharacteristics.numberOfFeatures.numberOfOutdoorParkingLots,
            viewFromProperty: propertyCharacteristics.features.viewFromProperty,
            hasASwimmingPool: propertyCharacteristics.features.hasASwimmingPool,

            // Conditions
            hasAcceptedTermsAndConditions: true,
            hasAnySharedPartBeenRenovatedRecently:
                propertyCharacteristics.conditions.hasAnySharedPartBeenRenovatedRecently,
            constructionYear: propertyCharacteristics.conditions.constructionYear,
            constructionPeriodMin: propertyCharacteristics.conditions.constructionPeriodMin,
            constructionPeriodMax: propertyCharacteristics.conditions.constructionPeriodMax,
            averageCondition: propertyCharacteristics.conditions.averageCondition,
            epcEnergyEfficiencyRating: propertyCharacteristics.conditions.epcEnergyEfficiencyRating,

            monthlyCondominiumFee: propertyCharacteristics.monthlyCondominiumFee,

            // Intent
            isAPrivatePerson: intent.isAPrivatePerson,
            isPropertyOwner: intent.isPropertyOwner,
            propertyMainUsage: intent.propertyMainUsage,
            job: intent.job,
            jobRole: intent.jobRole,
            authorContactDetailsId: intent.authorContactDetailsId,
        });
    }
}
